import { ReactNode } from 'react';

import {
  DashManIcon,
  GearManIcon,
  Label,
  OnlineWorkerIcon,
  OtherWorkerIcon,
  TTranslator,
} from '@smartshell/ui-kit';

import { IRole } from 'types';

import { TLocalesKeys } from '../localization';

export const getClientRoleLabel = (
  roles: Array<IRole>,
  t: TTranslator<TLocalesKeys>
): JSX.Element => {
  if (!roles.length) return <Label text={t('client')} />;

  const currentRole = roles.filter(({ id }) => id !== 4)[0];

  return <Label text={t(`roles.${currentRole.alias}`)} />;
};

export const getRoleIcon = (roles: { alias: string }[]): ReactNode => {
  if (roles.some((role) => role.alias === 'active_operator')) {
    return <OnlineWorkerIcon size="s" color="link-info" />;
  }
  if (roles.some((role) => role.alias === 'manager')) {
    return <GearManIcon size="s" color="link-info" />;
  }
  if (roles.some((role) => role.alias === 'operator')) {
    return <DashManIcon size="s" color="link-info" />;
  }
  return <OtherWorkerIcon size="s" color="link-info" />;
};
